import apiClient from './apiClient';
import { LoginRequest, RecommendationHistoryEntry } from "../types/types";

interface KeyValuePair {
    id: number;
    key: string;
    value: string;
    userId: number;
}
const authService = {
    login: async (credentials: LoginRequest) => await apiClient.post('/auth/login', credentials),
    get: async () => await apiClient.get('/auth/get'),
    getUserById: async (id:number) => await apiClient.get('/auth/getUserById?userId='+(id||0)),
    isAdmin: async () => await apiClient.post('/auth/is-admin'),
    getAccessContext: async () =>
        await apiClient.get<{ isAdmin: boolean; hasSubordinates: boolean; userId: number }>(
            '/auth/access-context',
        ),
    setManager: async (userId: number, managerId: number | null) =>
        await apiClient.post('/auth/set-manager', { userId, managerId }),
    getUsers: async () => await apiClient.get('/auth/get-users'),

    getKeyValues: async (userId?: number) => {
        const url = userId ? `/key-value?userId=${userId}` : '/key-value';
        return await apiClient.get(url);
    },
    getKeyValue: async (key: string, userId?: number) => {
        const params = userId ? { key, userId } : { key };
        return await apiClient.get('/key-value/by-key', { params });
    },
    createKeyValue: async (data: { value: string;
        key: string,
        userId?:number,
        imageBase64?:string,
        description?:string,
        imageMimeType?:string
    }) =>
        await apiClient.post('/key-value', data),
    updateKeyValue: async ( data: Partial<KeyValuePair>) =>
        await apiClient.put(`/key-value`, data),
    deleteKeyValue: async (id: number, userId?:number) => await apiClient.delete(`/key-value?id=${id}`+'&userId='+(userId||0)),
    applyKeyValuesToAllUsers: async (userId: number) =>
        await apiClient.post(`/key-value/apply-to-all/${userId}`),

    generateRecommendations: async (userId: number, keyPrompt: string) =>
        await apiClient.post('/auth/generate-recommendations', { userId, keyPrompt }),

    generateRecommendationsByReportId: async (payload: {
        userId: number;
        reportId?: number;
        keyPrompt?: string;
        promptId?: number;
        testConfigurationId?: number;
        userQuestion?: string;
    }) => await apiClient.post('/auth/generate-recommendations-report', payload),

    getRecommendationsHistory: async (params?: {
        reportId?: number;
        userId?: number;
        startDate?: string;
        endDate?: string;
    }) => {
        const search = new URLSearchParams();
        if (params?.reportId != null) search.set('reportId', String(params.reportId));
        if (params?.userId != null) search.set('userId', String(params.userId));
        if (params?.startDate) search.set('startDate', params.startDate);
        if (params?.endDate) search.set('endDate', params.endDate);
        const q = search.toString();
        const res = await apiClient.get<RecommendationHistoryEntry[]>(
            `/auth/get-history-recommendation${q ? '?' + q : ''}`
        );
        return res.data;
    },

    downloadDocument: async (documentId: string) => {
        return await apiClient.get(`/auth/document/${documentId}`, {
            responseType: 'blob',
        });
    },
    deleteDocument: async (documentId: string) => {
        return await apiClient.delete(`/auth/document/${documentId}`);
    },
    uploadDocument: async (formData: FormData) => {
        return await apiClient.post('/auth/document/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    getUserDocuments: async (userId?: number) => {
        const url = userId ? `/auth/documents?userId=${userId}` : '/auth/documents';
        return await apiClient.get(url);
    },
};

export default authService;
